import React from 'react';
import './TitleValueIconStyles.css';
import { classNames } from 'primereact/utils';

export interface ITitleValueIconProps {
  containerClassName?: string;
  valueClassName?: string;
  title: string;
  value: string | number;
  icon?: string;
}
export const TitleValueIcon: React.FC<ITitleValueIconProps> = ({
  containerClassName = '',
  valueClassName = '',
  title,
  value,
  icon = '',
}) => {
  return (
    <div className={classNames('tviContainer', containerClassName)}>
      <div className="horizontalContainer">
        <img alt={title} src={icon} />
        <p className="tviTitle">{title}</p>
      </div>
      <p className={classNames('tviValue', 'boldText', valueClassName)}>
        {value ?? 'Unknown'}
      </p>
    </div>
  );
};
export default TitleValueIcon;
